module.exports = __webpack_public_path__ + "img/120ne.6dc12912.svg";